var _line, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.25,
    y1: -0.25,
    x2: 8.23528,
    y2: -0.25,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 18 19.5)",
    stroke: "#424242",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    transform: "matrix(-1 0 0 1 14.5 0.5)",
    stroke: "#424242",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.da11756c8771afdefb88f2da1e43d9e9.svg";
export { ForwardRef as ReactComponent };